import React, { useEffect } from "react";
import { useRouter } from "next/router";
import { useSelector, useDispatch } from "react-redux";
import { setBankerRedirectUrl } from "store";

export default function BankerDashboardWrapper(props: any) {
  const router = useRouter();
  const dispatch = useDispatch();
  const userToken = useSelector((state: any) => {
    return state.bankerAuth.accessToken;
  });
  const currentBranch = useSelector((state: any) => {
    return state.bankerAuth.currentBranch;
  });

  useEffect(() => {
    if (!userToken) {
      router.push("/login");
    } else if (userToken && !currentBranch) {
      router.push("/branch");
    }
  }, []);

  useEffect(() => {
    if (!userToken && router.asPath) {
      dispatch(setBankerRedirectUrl(router.asPath));
    }
  }, [router]);

  return userToken && currentBranch ? props.children : null;
}
